import script from "./HeaderCreateSection.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderCreateSection.vue?vue&type=script&setup=true&lang=js"

import "./HeaderCreateSection.vue?vue&type=style&index=0&id=377410fa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-377410fa"]])

export default __exports__